import React, { forwardRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

function Captcha({ size = 'invisible', onChange }, ref) {
  return (
    <ReCAPTCHA
      ref={ref}
      size={size}
      sitekey={process.env.REACT_APP_CAPTCHA_KEY}
      onChange={onChange}
      badge="bottomright"
    />
  );
}

export default forwardRef(Captcha);
